var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M30 30 10 10m20 0L10 30","stroke":"#fff","strokeWidth":"2","strokeLinecap":"round"}));
}

Close.defaultProps = {"width":"40","height":"40","viewBox":"0 0 40 40","fill":"none"};

module.exports = Close;

Close.default = Close;
